import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { navigateTo } from "gatsby-link";
import { TextField, Grid } from '@material-ui/core';

function encode(data) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
  }

export default class RequestAccessForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = e => {
        e.preventDefault();
        const form = e.target;
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({
            "form-name": form.getAttribute("name"),
            ...this.state
            })
        })
            .then(() => navigateTo(form.getAttribute("action")))
            .catch(error => alert(error));
    };

    render() {
        return (
            <div className="request-form">
                <Form name="request-access-form" method="POST" action="/thanks/" data-netlify="true" data-netlify-honeypot="bot-field" onSubmit={this.handleSubmit}>
                    {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
                    <input type="hidden" name="form-name" value="request-access-form" />
                    <p hidden>
                        <label>
                        Don’t fill this out:{" "}
                        <input name="bot-field" onChange={this.handleChange} />
                        </label>
                    </p>
                    <h1>Try our awesome product.</h1>
                    <Form.Row className="align-items-center">
                    <Col xs="auto">
                        <Form.Label htmlFor="inlineFormInput" srOnly>
                        </Form.Label>
                        <Grid container direction="column" alignItems="center" justify="center">
                            <TextField 
                            required
                            id="outlined-basic" 
                            label="Email" 
                            fullWidth
                            variant="outlined"  
                            type="email" 
                            name="email" 
                            onChange={this.handleChange}
                            />
                        </Grid>
                    </Col>
                    <Col xs="auto">
                        <button type="submit" className="button">Request Early Access</button>
                    </Col>
                    </Form.Row>
                </Form>
            </div>
        )
    }
}